import { Select } from "@magnetic/select";

import { InputText } from "src/components/fields/input";

import type { Filter } from "./clientFilterTypes";

export interface ClientFilterFieldsProps {
  readonly filters: Filter[];
  readonly handleTextChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    filter: Filter
  ) => void;
}
export const ClientFilterFields = ({
  filters,
  handleTextChange
}: ClientFilterFieldsProps) => {
  return (
    <>
      {filters.map((filter: Filter) => {
        const {
          placeholder,
          type,
          value,
          name,
          label,
          setValue: onHandleChange
        } = filter;
        return (
          <div key={filter.name}>
            {type === "text" && (
              <InputText
                data-qa={`filter-${name}`}
                placeholder={placeholder}
                value={value}
                onChange={(e) => handleTextChange(e, filter)}
                name={name}
                label={label}
              />
            )}
            {type === "select" && (
              <Select
                data-qa={`filter-${name}`}
                placeholder={placeholder}
                value={value}
                onChange={onHandleChange}
                options={filter.options}
                menuWidth="auto"
                clearable={true}
                searchable={!!filter.searchable}
                fixedWidth={!!filter.fixedWidth}
              />
            )}
          </div>
        );
      })}
    </>
  );
};
